import { RitualgewaltEntry } from '@/model/ritualgewalt';

import { DataFetcher } from './fetcher/DataFetcher/index.ts';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface RitualgewaltSearchParams extends AbstractSearchParams {
  vaccine?: string;
  health_damage?: string;
  vaccine_manufacturer?: string;
  language?: string;
}

export class RitualgewaltRepository extends RepositoryNocoDbBase<RitualgewaltEntry, RitualgewaltSearchParams> {
  protected readonly TABLE_NAME = 'ritualgewalt';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly DATE_FIELD: 'CreatedAt';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS: (keyof RitualgewaltEntry)[] = [
    'type',
    'country',
    'gender',
    'source',
    'crime_scenes',
    'offender_category',
    'consciousness_control'
  ];

  protected readonly SEARCH_FIELDS: (keyof RitualgewaltEntry)[] = [
    'story_of_suffering',
    'damages',
    'cities',
    'name',
    'offender_category',
    'specific_klatv_documentation'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
